export const DESKTOP_BOTTOM_OFFSET = 20;
export const IOS_BOTTOM_OFFSET = 50;
